export const state = {
  dashboard: {
    category: {},
    columns: [],
    data: [],
    groups: [],
    id: '',
    measures: [],
    name: '',
    rows: [],
    title: '',
    type: '',
    url: '',
    worksheets: [],
  },
};
